<h2 mat-dialog-title>Emitir Nota Fiscal</h2>
<mat-dialog-content class="mat-typography">
    <h3>Deseja Emitir Nota Fiscal Eletronica da Venda?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Não</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Sim</button>
</mat-dialog-actions>